module.exports = __webpack_public_path__ + "img/boat.182dbce9.jpg";